<template>
  <a-row :gutter="10">
    <a-col :md="6" :sm="24">
      <a-card :bordered="false">
        <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px">
          <!-- 树-->
          <template>
            <!--组织机构-->
            <a-tree
              showLine
              :selectedKeys="selectedKeys"
              :checkStrictly="true"
              :defaultExpandAll="true"
              :autoExpandParent="true"
              @select="onSelect"
              :dropdownStyle="{maxHeight:'200px',overflow:'auto'}"
              :treeData="departTree"
            />
          </template>

        </div>
      </a-card>
    </a-col>
    <a-col :md="18" :sm="24">
      <a-card :bordered="false">
        <user :deptId="selectDeptId"/>
      </a-card>
    </a-col>

  </a-row>

</template>

<script>
import { queryDeptNode } from '@api/sys/dept'
import { treeDataTranslate } from '@/utils/util'
import user from '../user/user'
export default {
  name: 'Index',
  components: {
    user
  },
  data: () => {
    return {
      selectedKeys: [],
      departTree: [],
      selectDeptId: ''
    }
  },
  methods: {

    // 选择部门
    onSelect (selectedKeys, e) {
      if (this.selectedKeys[0] !== selectedKeys[0]) {
        this.selectedKeys = [selectedKeys[0]]
        this.selectDeptId = selectedKeys[0]
      }
    }
  },
  created () {
    queryDeptNode().then(res => {
      this.departTree = treeDataTranslate(res.data, 'deptId', 'name')
    })
  }
}
</script>

<style scoped>

</style>
